import { Title } from "components";
import * as styles from "./styles";
import {
  Articles,
  TextBio,
  AccomplishmentList,
  ImgCarousel,
} from "./components";

export default function Bio() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Title className="mb-10">ABOUT</Title>
        <div className="px-4 lg:px-0">
          <ImgCarousel />
          <TextBio />
        </div>
        <Title>AWARDS</Title>
        <div className="px-4 lg:px-0">
          <AccomplishmentList />
        </div>

        <Title>FEATURES</Title>
        <Articles />
      </div>
    </div>
  );
}

